module.exports = __webpack_public_path__ + "img/pwd.dff0baa4.png";